import { Notification, NotificationResponse } from './notification.type';

interface FetchNotificationsParams {
  page: number;
  limit: number;
}

export const getNotifications = async ({ page, limit }: FetchNotificationsParams): Promise<NotificationResponse> => {
  const response = await apiClient().get<Notification[]>('/notification', {
    params: {
      PageIndex: page,
      PageSize: limit,
    },
  });

  let hasMore = false;

  if (response.metaData) {
    hasMore = response.metaData.totalItems! > response.metaData.pageIndex! * response.metaData.pageSize!;
  }

  return {
    notifications: response.data,
    nextPage: hasMore ? page + 1 : undefined,
    hasMore,
  };
};

export const getUnreadCount = async () => {
  return await apiClient().get<number>('notification/unread-count');
};

export const markAsRead = async (id: number) => {
  return apiClient().put(`/notification/${id}/mark-as-read`);
};

export const markAllAsRead = async () => {
  return apiClient().put('/notification/batch-mark-as-read');
};
